<section class="page-container">
  <div class="flex min-w-0 items-center justify-between gap-4">
    <h1 class="main-heading min-w-0">Shipment / Production Master</h1>
    <app-navpath class="hidden md:block"></app-navpath>
  </div>

  <ul class="tabs-container overflow-x-auto">
    <li (click)="onTabSelect('newShipment')" [ngClass]="selectedTab === 'newShipment' ? 'tab-item_selected' : 'tab-item'">
      New Shipment / Production
    </li>
    <li (click)="onTabSelect('updateShipment')" [ngClass]="selectedTab === 'updateShipment' ? 'tab-item_selected' : 'tab-item'">
      Update Shipment
    </li>
    <li (click)="onTabSelect('shipmentHistory')" [ngClass]="selectedTab === 'shipmentHistory' ? 'tab-item_selected' : 'tab-item'">
      Shipment History
    </li>
  </ul>

  <div class="content-container__tabs">
    <div *ngIf="selectedTab === 'newShipment'">
      <p class="mb-4 text-sm">
        You are only allowed to enter one shipment entry for a particular month. If you need to add or remove entries for previous months, use the Shipment History tab.
      </p>
      <app-data-form [dataFields]="newShipmentFormFields" (updateFields_child)="onNewShipmentFormChange($event)"></app-data-form>
      <div class="mb-4 flex w-full flex-col gap-1 sm:w-fit sm:flex-row">
        <button (click)="onClearForm()" class="shorter-btn clear-btn"><fa-icon [icon]="faEraser" class="mr-1"></fa-icon>Clear</button>
        <button (click)="onAddEntry()" class="shorter-btn misc-btn"><fa-icon [icon]="faPlus" class="mr-1"></fa-icon>Add</button>
      </div>
      <div class="content-container w-full overflow-x-auto">
        <app-data-table class="block min-w-[950px]" [tableHeaders]="newShipmentTableHeaders" [tableEntries]="newShipmentTableEntries" [pagination]="false" (remove)="onRemoveEntry($event)"></app-data-table>
      </div>
      <div class="mt-4 flex w-full sm:w-fit">
        <button (click)="onSaveEntries()" [disabled]="pendingShipments.length === 0" class="shorter-btn misc-btn disabled:cursor-not-allowed disabled:opacity-50"><fa-icon [icon]="faSave" class="mr-1"></fa-icon>Save New Shipment</button>
      </div>
    </div>

    <div *ngIf="selectedTab === 'updateShipment'">
      <app-data-form *ngIf="!isEditingShipment" [dataFields]="updateShipmentEntryFormFields" (updateFields_child)="onUpdateShipmentEntryChange($event)"></app-data-form>
      <div *ngIf="isEditingShipment" class="mb-4">
        <app-data-form [dataFields]="shipmentEditFormFields" (updateFields_child)="onEditShipmentFormChange($event)"></app-data-form>
        <div class="mb-4 flex w-full flex-col gap-1 sm:w-fit sm:flex-row">
          <button (click)="onUpdateShipmentDetails()" class="shorter-btn misc-btn"><fa-icon [icon]="faSave" class="mr-1"></fa-icon>Update</button>
          <button (click)="onCancelEdit()" class="shorter-btn clear-btn"><fa-icon [icon]="faEraser" class="mr-1"></fa-icon>Cancel</button>
        </div>
      </div>
      <p *ngIf="!isEditingShipment && updateShipmentTableEntries.length === 0" class="mb-4 text-sm">No Existing Shipment found in the system.</p>
      <div *ngIf="!isEditingShipment" class="content-container w-full overflow-x-auto">
        <app-data-table class="block min-w-[1100px]" [tableHeaders]="updateShipmentTableHeaders" [tableEntries]="updateShipmentTableEntries" [pagination]="false" (edit)="editShipmentEntry($event)" (remove)="removeShipmentEntry($event)"></app-data-table>
      </div>
    </div>

    <div *ngIf="selectedTab === 'shipmentHistory'">
      <div class="mb-4 flex w-full flex-col gap-2 lg:flex-row lg:items-center">
        <app-data-form class="shipment-history-entry block w-full lg:max-w-2xl" [columns]="0" [dataFields]="shipmentHistoryFormFields" (updateFields_child)="onShipmentHistoryEntryChange($event)"></app-data-form>
        <div *ngIf="shipmentHistoryTableEntries.length > 0" class="flex w-full flex-col gap-1 sm:w-fit sm:flex-row">
          <button (click)="setAllHistoryEntries(true)" class="shorter-btn misc-btn"><fa-icon [icon]="faCheck" class="mr-1"></fa-icon>Check All</button>
          <button (click)="setAllHistoryEntries(false)" class="shorter-btn misc-btn"><fa-icon [icon]="faUndo" class="mr-1"></fa-icon>Uncheck All</button>
        </div>
      </div>
      <p *ngIf="shipmentHistoryTableEntries.length === 0" class="mb-4 text-sm">No Existing Shipment found in the system.</p>
      <div class="content-container w-full overflow-x-auto">
        <app-data-table class="block min-w-[1100px]" [tableHeaders]="shipmentHistoryTableHeaders" [tableEntries]="shipmentHistoryTableEntries" [pagination]="false"></app-data-table>
      </div>
      <div *ngIf="shipmentHistoryTableEntries.length > 0" class="mt-4">
        <app-data-form [dataFields]="updateShipmentHistoryFormFields"></app-data-form>
        <div class="mt-4 flex w-full flex-col gap-1 sm:w-fit sm:flex-row">
          <button (click)="onUpdateEtaRemarks()" class="shorter-btn misc-btn"><fa-icon [icon]="faSave" class="mr-1"></fa-icon>Update Remarks</button>
          <button (click)="onUpdateEtaDate()" class="shorter-btn misc-btn"><fa-icon [icon]="faSave" class="mr-1"></fa-icon>Update ETA Date</button>
        </div>
      </div>
    </div>
  </div>
</section>
